import "@/styles/ctags.css";
import "./style.css";
//import 'vue-range-component/dist/vue-range-slider.css';
//
import TagBlock from "@/components/Tags/TagBlock.vue";
import data from "@/components/Tags/data";
import {catchhandler, get} from "@geekjob/lib/http";
import * as storage from "@/lib/storage";
import VueRangeSlider from 'vue-range-component';
//
var $serp = $('#serplist'),
	$paginator = $('#paginator'),
	$showmorebtn = $('#showmorebtn'),
	$upbtn = $('#upbtn'),
	$serpprogressbar = $('#serpprogressbar'),
	$title = $('title'),
	endmsg = `65% работодателей ищут кандидатов, не размещая вакансии.<br>
<a class="link blue-text text-darken-1" href="//my.${document.domain}/cv/edit">Разместите резюме с подробным описанием</a>,
чтобы повысить свой шанс найти работу.<br>
Вы так же можете <a class="link blue-text text-darken-1" href="//my.${document.domain}/cv/edit">разместить анонимное резюме</a>`
;
//
$serpprogressbar.showBar = function () {
	clearTimeout(this.__timer);
	this.__timer = setTimeout(() => this.hide(), 1e4);
	this.show();
};
$serpprogressbar.hideBar = function () {
	clearTimeout(this.__timer);
	this.hide();
};

function scrollToSerp() {
	$('html, body').animate({scrollTop: $('#serpanchor').offset().top}, 'slow')
}

//
export default {
	components: {TagBlock, VueRangeSlider},
	//
	data() {
		return {
			profileTags: window?.User?.ptags ?? '',
			query: '',
			extfilters1: true,
			extfilters2: false,
			data: data.tree,
			selectedFindInputTags: [],
			selectedInputTags: [],
			notagency: false,
			loading: false,
			onlysales: false,
			inhouse: false,
			parttime: false,
			relocate: false,
			remote: false,
			nextpage: 1,
			showmorebtn: null,
			documentsCount: 0,
			money: 120000,
			showBanner4Analyst: false,
			sortby: 0
		}
	},
	//
	created() {
		$showmorebtn.click(() => {
			this.sendForm()
		});
		setTimeout(function () {
			$upbtn.show()
		}, 3e3);

		let selectedFiltersA = []; //storage.get('filters-vacancy-a');
		//let selectedFiltersB = storage.get('filters-vacancy-b');
		let selectedFiltersB = [];
		let selectedFiltersC = '';

		try {
			let h = new URLSearchParams(window.location.hash.substr(1));
			let q = window.location.searchParams;
			let f = s => h.get(s) || q.get(s);

			if (f('t')) selectedFiltersA = f('t').split(',').map(x => parseInt(x));
			if (f('qs')) selectedFiltersC = f('qs');
			//if (f('f')) selectedFiltersB = q.get('f').split(',').map(x => parseInt(x));
			if (f('f')) selectedFiltersB = f('f').split(',').map(x => parseInt(x));

			if (f('s')) this.onlysales = true;
			if (f('pt')) this.parttime = true;
			if (f('rl')) this.relocate = true;
			if (f('ih')) this.inhouse = true;
			if (f('rm')) this.remote = true;
			if (f('na')) this.notagency = true;
		} catch (e) {
			console.error(e)
		}

		switch (true) {
			case this.remote:
			case this.onlysales:
			case this.parttime:
			case this.inhouse:
			case this.relocate:
			case this.anonim:
				this.extfilters1 = true;
				break;
		}

		if (selectedFiltersA && selectedFiltersA.length) {
			this.selectedInputTags = selectedFiltersA;
			this.extfilters1 = true;
			this.extfilters2 = true;
		}
		// if (selectedFiltersB && selectedFiltersB.length) {
		// 	this.selectedFindInputTags = selectedFiltersB;
		// 	this.extfilters1 = true;
		// 	this.extfilters2 = true;
		// }
		if (selectedFiltersC && selectedFiltersC.length) {
			//this.extfilters1 = false;
			this.extfilters2 = false;
			this.query = selectedFiltersC;
		}
	},
	//
	mounted() {
		M.updateTextFields();
		if (this.query.length) {
			this.sendForm(1);
			if (this.onlysales || this.parttime || this.inhouse || this.remote || this.relocate || this.anonim) {
				this.extfilters1 = true
			}
		} else if (this.selectedInputTags.length || this.selectedFindInputTags.length) {
			this.extfilters1 = true;
			this.extfilters2 = true;
			this.sendForm(1)
		}
	},
	//
	updated() {
		M.updateTextFields()
	},
	//
	methods: {
		getSuitable() {
			$serp.html(`<li class="collection-item"><b>Вакансии на основе вашего профиля</b></li>`);
			this.changeURI('/vacancies?or='+this.profileTags, 'Find suitable vacancies');
			this.sendRequest('/json/find/vacancy?page=' + this.nextpage + '&or='+this.profileTags);
			scrollToSerp();
		},
		//
		changeURI(url, search) {
			var t = '';
			try {
				t = 'Вакансии ' + search
					.map(s => decodeURIComponent(s.replace(/^[a-z]+=/, '')).trim())
					.join(' ')
					.replace(/\d+/g, '')
			} catch {}
			history.pushState(search, t, url);
			$title.text(t);
		},
		//
		clearForm() {
			storage.set('filters-vacancy-a', null);
			storage.set('filters-vacancy-b', null);
			//this.selectedFindInputTags = [];
			this.selectedInputTags = [];
			// window.location.hash = '';
			// window.location.search = '';
			// setTimeout(_=>window.location.reload(),1e3);
			location = '/vacancies'
		},
		//
		sendForm(newreq = false) {
			$serpprogressbar.showBar();
			$paginator.html('Загрузка данных...');
			if (newreq) {
				this.nextpage = 1;
				this.documentsCount = 0;
				//location.hash = '#serp';
				$showmorebtn.show();
			}
			//
			let search = [];
			if (this.onlysales) {
				search.push('s=1');
				search.push('money='+this.money);
			}
			if (this.parttime) search.push('pt=1');
			if (this.inhouse) search.push('ih=1');
			if (this.remote) search.push('rm=1');
			if (this.relocate) search.push('rl=1');
			if (this.notagency) search.push('na=1');
			if (this.sortby) search.push(`sort=${this.sortby}`);
			//
			//
			if (this.query) {
				search.push('qs=' + encodeURIComponent(this.query));
				if (this.selectedInputTags && this.selectedInputTags.length) {
					search.push('t=' + this.selectedInputTags.join(','))
				}
			} else {
				if (this.$refs.tagBlock) {
					let a = this.$refs.tagBlock.getAllSelectedTags();
					if (a.length) search.push('t=' + a.join(','))
					storage.set('filters-vacancy-a', a || null);
				}
				// if (this.selectedFindInputTags && this.selectedFindInputTags.length) {
				//     search.push('f=' + this.selectedFindInputTags.join(','))
				// }
			}

			this.sendRequest('/json/find/vacancy?page=' + this.nextpage + '&' + search.join('&'))

			//
			if (this.nextpage < 1) {
				this.noMoreSearchData();
				return;
			}
			//
			if (newreq) {
				//window.location.hash = '#' + search.join('&');
				this.changeURI('/vacancies?' + search.join('&'), search);
				scrollToSerp();
				if (search.join('&').match(/data|52|107/i)) {
					$('#promo_newhr_dataanal').show()
					$('#promo_newhr_dataanal1').show()
				}
			}
		},
		sendRequest(url) {
			let catchHandler = catchhandler.bind(this);
			get
				.call(this, url, true)
				.then(res => {
					$paginator.html('');
					//
					if (res.error || (res.data.length < 1)) {
						$serp[res.error ? 'html' : 'append'](
							`<li class="collection-item center-align">По такому запросу мы не нашли удовлетворяющих результатов. Но... <br>${endmsg}</li>`
						);
						$showmorebtn.hide();
						$serpprogressbar.hideBar();
						this.documentsCount = 0;
						if (res.error) catchHandler(res.error);
						return;
					}
					//
					res.nextpage = parseInt(res.nextpage);
					this.nextpage = res.nextpage;
					this.documentsCount = res.documentsCount;
					//
					if (res.page == 1) $serp.html('');
					if (this.nextpage < 1) this.noMoreSearchData();
					//
					let htmls = '';
					for (let vacancy of res.data) {
						htmls += `
<li class="collection-item avatar">
	<div class="info">${[vacancy.city, vacancy.country].filter(x => x).join(', ')}<br>${vacancy.salary}</div>
	<a href="/vacancy/${vacancy.id}" target="_blank">${
							vacancy.company.logo && 3!=vacancy.company.type
								? `<div class="company-list-logo" style="background-image:url('/storage/company/${vacancy.company.id}/logo/${vacancy.company.logo}')"></div>`
								: `<div class="geek-list-logo">${vacancy.company?.name?.substr(0, 2)?.toUpperCase()}</div>`
						}</a>
	<p class="truncate vacancy-name"><a href="/vacancy/${vacancy.id}" target="_blank" class="title">${vacancy.position}</a></p>
	<p class="truncate company-name">
		<a href="/vacancy/${vacancy.id}" target="_blank">${vacancy.company.name}</a>
		<small>${['&nbsp;Freelancer','','&nbsp;(агентство)','&nbsp;(частный рекрутер)'][vacancy.company.type] ?? ''}</small>
	</p>
	<div class="info">${

							(vacancy.jobFormat.relocate ? '<span class="relocate-label">relocate</span>&nbsp;' : '') +
							(vacancy.jobFormat.remote ? '<span class="remote-label">remote</span>&nbsp;' : '') +
							(vacancy.jobFormat.parttime ? '<span class="parttime-label">parttime</span>&nbsp;' : '') +
							(vacancy.jobFormat.inhouse ? '<span class="inhouse-label">office</span>&nbsp;' : '')

						}</div>
	<p class="truncate datetime-info">${vacancy.log.modify}</p>
</li>`;
					}

					$serp.append(htmls);
					setTimeout(function () {
						$serpprogressbar.hideBar()
					}, 1e3);
				})
				.catch(catchHandler)
		},
		noMoreSearchData() {
			$paginator.html(`<p class="center-align">${endmsg}</p>`);
			$showmorebtn.hide();
			$serpprogressbar.hideBar();
		},
		showFilters() {
			this.extfilters1 = true;
		},
		showSubFilters() {
			this.extfilters2 = true;
			this.query = '';
		},
		hideFilters() {
			this.extfilters1 = false;
			this.extfilters2 = false;
			setTimeout(() => {
				this.$refs.queryinput.focus()
			}, 0);
		},
		hideSubFilters() {
			this.extfilters2 = false;
			setTimeout(() => {
				this.$refs.queryinput.focus()
			}, 0);
		},
		clearQueryInput() {
			this.query = '';
			this.changeURI('/vacancies', ['IT', '&', 'Digital']);
		},
		quickFind(qs) {
			this.query = qs;
			this.sendForm(true);
		},
		detectIfAnalystGeek(val) {
			if (/analyst|analytic|аналитик/i.test(val)) {
				if (/head|product|продуктовый|бизнес|busines/i.test(val) || /BI/.test(val)) {
					this.showBanner4Analyst = true
				}
			}
			else {
				this.showBanner4Analyst = false
			}
		},
	},
	computed: {
		queryLength() {
			return this.query.length > 0
		}
	},
	watch: {
		query: function (nv) {
			this.detectIfAnalystGeek(nv)
		},
	}
}
